import { setLanguageCookie } from "@jti/ui/components/LanguageSelector";

import type { ShopPageTeaserType } from "./ShopLandingPage";

import "./ShopLandingPage.scss";

const rootClassName = "shopLandingPage";

export const ShopPageTeaser = ({ title, path, backgroundImage: image, relatedLanguage }: ShopPageTeaserType) => {
  const selectLocation = (path: string, selectedLanguage: string) => {
    setLanguageCookie(selectedLanguage);
    window.location.assign(path);
  };

  return (
    <li
      className={`${rootClassName}__teaser`}
      tabIndex={0}
      role="link"
      data-testid="shop-page-teaser"
      style={{
        backgroundImage: `url('${image}')`,
        backgroundSize: "cover",
        borderRadius: "10px",
      }}
      onClick={() => selectLocation(path, relatedLanguage)}
      onKeyDown={(e) => e.key === "Enter" && selectLocation(path, relatedLanguage)}
    >
      <strong className={`${rootClassName}__teaser-title`}>{title}</strong>
    </li>
  );
};
